import styled from 'styled-components';
import { Button } from 'antd';
import Image from 'global/Image';
import BaseModal from 'global/Modal/BaseModal';

export const BaseOtpLimitModal = styled(BaseModal)`
  .ant-modal-body {
    padding: 32px 40px;
  }
`;

export const ModalIllustration = styled(Image)`
  width: 160px;
  height: auto;
`;

export const BackButton = styled(Button)`
  &.ant-btn.ant-btn-primary {
    height: auto;
    width: 100%;
    padding: 12.5px;
    border: none;

    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
  }
`;
